import { type FC, type ReactNode } from "react";

import { type Permissions } from "../../gql-generated/aliases";
import { useSelectedOrganization } from "../../organizations/hooks/useSelectedOrganization";

import { Visible } from "./Visible";

interface VisibleWhenPermittedProps {
    children: ReactNode;
    when(permission: Permissions): boolean;
}

export const VisibleWhenPermitted: FC<VisibleWhenPermittedProps> = ({ when, children }) => {
    const { permissions } = useSelectedOrganization();

    return <Visible when={when(permissions)}>{children}</Visible>;
};
